module.exports = __webpack_public_path__ + "img/home-dark.fba046ca.svg";